import * as _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService, AlertService } from 'ng-jhipster';
import { forkJoin } from 'rxjs/observable/forkJoin';

import { Account,  Principal } from '../shared';
import { Student, StudentService } from '../entities/student';
import { CardTypeService, CardType } from '../entities/card-type';
import { SchoolCalendarService, SchoolCalendar } from '../entities/school-calendar';
import { SubscriptionTypeService, SubscriptionType } from '../entities/subscription-type';
import { CardService, Card } from '../entities/card';
import { EnrollmentService, Enrollment } from '../entities/enrollment';

import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

enum TimePeriod {
    TODAY = 0,
    PERIOD = 1
};

@Component({
    selector: 'jyogui-card-dashboard-today',
    templateUrl: './card-dashboard-today.component.html',
    styleUrls: [
        'card-dashboard-today.scss'
    ]
})
export class CardDashboardTodayComponent implements OnInit {
    // TODO: mutialize this component with dashboard component because all the logic is duplicated

    account: Account;
    modalRef: NgbModalRef;
    student: Student;
    schoolCalendars: SchoolCalendar[];
    selectedSchoolCalendar: SchoolCalendar;
    today: any;
    cardTypes: CardType[];
    subscriptionTypes: SubscriptionType[];
    cards: any;
    enrollments: any;

    view: any[] = [1400, 250];

    colorSchemeCards = {
        domain: ['#596323', '#C8C234', '#BFAA34', '#8F5238', '#532D32']
    };

    colorSchemeEnrollments = {
        domain: ['#7380A5', '#232120', '#972D1D', '#DABB52', '#9FA5B2']
    };

    private baseQuery: string;

    constructor(
        private alertService: AlertService,
        private jhiLanguageService: JhiLanguageService,
        private principal: Principal,
        private cardTypeService: CardTypeService,
        private cardService: CardService,
        private enrollmentService: EnrollmentService,
        private schoolCalendarService: SchoolCalendarService,
        private studentService: StudentService,
        private subscriptionTypeService: SubscriptionTypeService,
        private languageService: JhiLanguageService
    ) {
        this.jhiLanguageService.setLocations(['dashboard']);
        this.cards = {
            [TimePeriod.TODAY]: [],
            [TimePeriod.PERIOD]: []
        };
        this.enrollments = {
            [TimePeriod.TODAY]: [],
            [TimePeriod.PERIOD]: []
        };
    }

    ngOnInit() {
        this.today = new Date();
        this.principal.identity().then((account) => {
            this.account = account;

            this.searchCurrentStudent()
            .add(() => {
                this.searchSchoolCalendar()
                .add(() => {
                    // Search for the card types
                    this.searchCardTypes()
                    .add(() => {
                        // Once retrieved the card types, look up for the cards
                        this.countFor('card', TimePeriod.TODAY);
                        this.countFor('card', TimePeriod.PERIOD);
                    });
                });
            });
        });
    }

    public selectedSchoolCalendarChanged($event) {
        this.countFor('card', TimePeriod.PERIOD);
    }

    private searchCurrentStudent() {
        return this.studentService.getCurrent()
            .subscribe((student: Student) => {
                this.student = student;
                this.baseQuery = `school.id:${this.student.schoolId}`;
            });
    }

    private searchSchoolCalendar() {
        const datePipe = new DatePipe(this.languageService.currentLang);
        const today = datePipe.transform(this.today, 'yyyy-MM-dd');
        const query = `school.id:${this.student.schoolId}`;

        return this.schoolCalendarService.search({
            query: query,
            sort: ['begining,desc']
        })
        .subscribe((res: HttpResponse<SchoolCalendar[]>) => {
            this.schoolCalendars = res.body;
            // Take the last one
            this.selectedSchoolCalendar = this.schoolCalendars[0];
        });
    }

    private searchCardTypes() {
        return this.cardTypeService.search({
            query: this.baseQuery,
            sort: []
        })
        .subscribe((res: HttpResponse<CardType[]>) => {
            this.cardTypes = res.body;
            return res;
        });
    }

    private countFor(name: string, period: TimePeriod, typeName?: string) {
        const baseType = typeName ? `${typeName}Type` : `${name}Type`;
        const datePipe = new DatePipe(this.languageService.currentLang);
        const today = datePipe.transform(this.today, 'yyyy-MM-dd');
        const beginning = datePipe.transform(this.selectedSchoolCalendar.begining, 'yyyy-MM-dd');
        const ending = datePipe.transform(this.selectedSchoolCalendar.ending, 'yyyy-MM-dd');

        let query = this.baseQuery;
        if (period === TimePeriod.TODAY) {
            query += ` AND validSince:[* TO ${today}] AND validUntil:[${today} TO *]`;
        } else if (period === TimePeriod.PERIOD) {
            query += ` AND validUntil:[${beginning} TO ${ending}]`;
        }

        const requests = [];
        _.each(this[`${baseType}s`], (type) => {
            const queryByType = `${query} AND ${baseType}.id:${type.id}`;
            requests.push(this[`${name}Service`].count({ query: queryByType, sort: [] })
                .map((count: number) => {
                    return {
                            name: type.name,
                            value: count
                        };
                }));
        });

        forkJoin(requests)
        .subscribe((countsByType: any) => {
            const countSum = _.chain(countsByType)
                .map((countByType) => {
                    return countByType.value;
                })
                .reduce((countValue, total) => {
                    return countValue + total;
                }, 0)
                .value();

            let sortedCountByTypes = _.sortBy(countsByType, 'value').reverse();
            this[`${name}s`][period] = (countSum > 0) ? sortedCountByTypes : [];
        });
    }

    private onError(error) {
        this.alertService.error(error.error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/card-dashboard-today/card-dashboard-today.component.ts